import StoreSettingPage from './StoreSettingPage'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/storeSettings',
      component: StoreSettingPage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/storeSettings/storeSettingConfig.js